// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610121407/js/" + chunkId + "." + {"44":"a88758cf","225":"10d2a1ea","481":"9c7b2cbd","486":"37973fde","770":"d883b7a6"}[chunkId] + ".0.4863886144549925.chunk.js";
};